import { Link } from '@/app/components/Link/Link'
import { useScrollHide } from '@/app/hooks/useScrollHide'
import ChatSvg from '@/app/icons/chat.svg?react'
import DailySvg from '@/app/icons/daily.svg?react'
import InstrumentsSvg from '@/app/icons/instruments.svg?react'
import classNames from 'classnames'
import type { FunctionalComponent } from 'preact'
import { useLayoutEffect, useState } from 'preact/hooks'
import { useLocation } from 'wouter-preact'
import styles from './index.module.scss'

export const MenuFooter: FunctionalComponent = () => {
  const [location] = useLocation()
  const [pathname, setPathname] = useState(location)
  const hidden = useScrollHide()

  useLayoutEffect(() => {
    if (typeof window !== 'undefined') {
      setPathname(window.location.pathname)
    }
  }, [location])

  return (
    <div class={styles.wrapper}>
      <div
        class={classNames(styles.footer, {
          [styles.hidden]: hidden,
        })}
      >
        <Link
          to='~/start'
          class={classNames(styles.item, {
            [styles.active]: pathname?.startsWith('/start'),
          })}
        >
          <div class={styles.icon}>
            <DailySvg />
          </div>
          <div class={styles.label}>
            Дейлик
          </div>
        </Link>
        <Link
          to='~/tools'
          class={classNames(styles.item, {
            [styles.active]: pathname?.startsWith('/tools')
              || pathname?.startsWith('/topics')
              || pathname?.startsWith('/moon'),
          })}
        >
          <div class={styles.icon}>
            <InstrumentsSvg />
          </div>
          <div class={styles.label}>
            Разборы
          </div>
        </Link>

        <Link
          to='~/chats'
          class={classNames(styles.item, {
            [styles.active]: pathname?.startsWith('/chats'),
          })}
        >
          <div class={styles.icon}>
            <ChatSvg />
          </div>
          <div class={styles.label}>
            Чаты
          </div>
        </Link>
      </div>
    </div>
  )
}
